export const environment = {
  production: false,
  urlControlCenterApi:
    'https://ccenter-api.dev.sla-logistics-rmc.devtest.gf.aws.scania.com/',
  redirectUri:
    'https://ccenter.dev.sla-logistics-rmc.devtest.gf.aws.scania.com/',
  protectedResource:
    'https://ccenter-api.dev.sla-logistics-rmc.devtest.gf.aws.scania.com',
};
